import { LOGOUT_ACTION } from "../types";

export default function() {
  return {
    type: LOGOUT_ACTION,
  }
}
